<div #hostElement [class.visibility-hidden]="isLoading | async" class="image-container">
    <canvas #heatmapCanvas></canvas>
    <img #imageRef [src]="img" alt="Heatmap Image" style="display:none;"/>
</div>

@if (isLoading | async) {
    <div class="d-flex flex-center align-items-center loader-container">
        <mat-spinner></mat-spinner>
    </div>
}
